import React from 'react';
import { Card } from '../ui/Card';
import { Utensils, CalendarDays, ShoppingBag, RefreshCw } from 'lucide-react';
export function Mechanism() {
  return <section className="py-20 bg-stone-50" data-id="element-46">
      <div className="container mx-auto px-4" data-id="element-47">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-48">
          <span className="text-red-700 font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-49">
            Cómo funciona
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-50">
            El Sistema 4×4
          </h2>
          <p className="text-lg text-stone-600" data-id="element-51">
            No te damos 365 recetas para que te pierdas. Te damos una lógica
            simple para que nunca te estanques.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-52">
          <Card className="text-center hover:shadow-md transition-shadow" data-id="element-53">
            <div className="w-14 h-14 mx-auto bg-orange-100 rounded-full flex items-center justify-center mb-4 text-orange-600" data-id="element-54">
              <Utensils className="h-7 w-7" data-id="element-55" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-56">
              4 Proteínas Base
            </h3>
            <p className="text-stone-600" data-id="element-57">
              Domina lo básico. Pollo, carne, cerdo o vegetariano. Preparados de
              forma simple y rápida.
            </p>
          </Card>

          <Card className="text-center hover:shadow-md transition-shadow" data-id="element-58">
            <div className="w-14 h-14 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-4 text-green-600" data-id="element-59">
              <Utensils className="h-7 w-7" data-id="element-60" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-61">
              4 Guarniciones
            </h3>
            <p className="text-stone-600" data-id="element-62">
              Acompañamientos versátiles que funcionan con todo. Arroz,
              vegetales, ensaladas y más.
            </p>
          </Card>

          <Card className="text-center hover:shadow-md transition-shadow" data-id="element-63">
            <div className="w-14 h-14 mx-auto bg-red-100 rounded-full flex items-center justify-center mb-4 text-red-600" data-id="element-64">
              <RefreshCw className="h-7 w-7" data-id="element-65" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-66">
              Salsas Latinas
            </h3>
            <p className="text-stone-600" data-id="element-67">
              El secreto para cambiar el sabor sin complicarte. Salsas y
              condimentos que dan vida.
            </p>
          </Card>

          <Card className="text-center hover:shadow-md transition-shadow" data-id="element-68">
            <div className="w-14 h-14 mx-auto bg-blue-100 rounded-full flex items-center justify-center mb-4 text-blue-600" data-id="element-69">
              <CalendarDays className="h-7 w-7" data-id="element-70" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-71">
              12 Semanas
            </h3>
            <p className="text-stone-600" data-id="element-72">
              Todo organizado en un calendario trimestral con listas de súper
              semanales.
            </p>
          </Card>
        </div>
      </div>
    </section>;
}